import styled from 'styled-components';
import colors from 'Styles/colors';

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  color: ${({ theme }) => theme.textfield.text};

  tbody tr:nth-child(even) {
    background-color: ${({ theme }) => theme.textfield.background};
  }
`;
Table.displayName = 'Table';

export const HeaderCell = styled.th`
  padding: 9px 10px;
  border-top: 1px solid ${({ theme }) => theme.textfield.shadow};
  border-bottom: 1px solid ${({ theme }) => theme.textfield.shadow};
  text-align: left;
  font-size: 12.5px;
  font-weight: 600;
  color: ${colors.grey17};
`;
HeaderCell.displayName = 'HeaderCell';

export const Cell = styled.td`
  padding: 8px 10px;
  font-size: 13.5px;
  overflow-wrap: anywhere;
`;
Cell.displayName = 'Cell';

export const Empty = styled.div`
  padding: 7px 10px;
  font-size: 13.5px;
  color: ${({ theme }) => theme.textfield.text};
`;
Empty.displayName = 'Empty';
